// removed by extract-text-webpack-plugin
module.exports = {"Label":"Unit__Label__3c-qn","Content":"Unit__Content__3kqgm","LowLevel":"Unit__LowLevel__Q5uKs","Light":"Unit__Light__2wQ1b","MidLevel":"Unit__MidLevel__1wvd7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Unit/Unit.css
// module id = 95
// module chunks = 0